import CryptoJS from "crypto-js";
import Cookies from "js-cookie";
import dateFormat, { masks } from "dateformat";

class HelperClass {
  constructor() { }
  isLogin() {
    if (
      Cookies.get("acn__") == null ||
      Cookies.get("acn__") === undefined ||
      Cookies.get("acn__") === "" ||
      Cookies.get("tkn__") === undefined ||
      Cookies.get("tkn__") === null ||
      Cookies.get("tkn__") === ""
    ) {
      return false;
    } else {
      var bytes = CryptoJS.AES.decrypt(
        Cookies.get("tkn__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (bytes == "") {
        window.location.replace("/login");
        return false;
      }
      var tkn__ = bytes.toString(CryptoJS.enc.Utf8);

      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("acn__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        window.location.replace("/login");
        return false;
      }
      var acn__ = secByte.toString(CryptoJS.enc.Utf8);

      if (tkn__ == "" || acn__ == "") {
        window.location.replace("/login");
        return false;
      } else {
        return true;
      }
    }
  }

  isAdminLogin() {
    if (
      Cookies.get("admin_acc__") == null ||
      Cookies.get("admin_acc__") === undefined ||
      Cookies.get("admin_acc__") === "" ||
      Cookies.get("admin_token__") === undefined ||
      Cookies.get("admin_token__") === null ||
      Cookies.get("admin_token__") === ""
    ) {
      return false;
    } else {
      var bytes = CryptoJS.AES.decrypt(
        Cookies.get("admin_token__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (bytes == "") {
        window.location.replace("/nsaccess");
        return false;
      }
      var admin_token__ = bytes.toString(CryptoJS.enc.Utf8);

      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("admin_acc__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        window.location.replace("/nsaccess");
        return false;
      }
      var admin_acc__ = secByte.toString(CryptoJS.enc.Utf8);

      if (admin_token__ == "" || admin_acc__ == "") {
        window.location.replace("/nsaccess");
        return false;
      } else {
        return true;
      }
    }
  }

  getCompName() {
    if (
      Cookies.get("comp_nme__") == null ||
      Cookies.get("comp_nme__") === undefined ||
      Cookies.get("comp_nme__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("comp_nme__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var comp_nme__ = secByte.toString(CryptoJS.enc.Utf8);

      if (comp_nme__ == "") {
        return false;
      } else {
        return comp_nme__;
      }
    }
  }

  getName() {
    if (
      Cookies.get("name__") == null ||
      Cookies.get("name__") === undefined ||
      Cookies.get("name__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("name__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var name__ = secByte.toString(CryptoJS.enc.Utf8);

      if (name__ == "") {
        return false;
      } else {
        return name__;
      }
    }
  }

  getEmail() {
    if (
      Cookies.get("eml__") == null ||
      Cookies.get("eml__") === undefined ||
      Cookies.get("eml__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("eml__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var eml__ = secByte.toString(CryptoJS.enc.Utf8);

      if (eml__ == "") {
        return false;
      } else {
        return eml__;
      }
    }
  }

  getTitle() {
    if (
      Cookies.get("title__") == null ||
      Cookies.get("title__") === undefined ||
      Cookies.get("title__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("title__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var title__ = secByte.toString(CryptoJS.enc.Utf8);

      if (title__ == "") {
        return false;
      } else {
        return title__;
      }
    }
  }

  getAddress() {
    if (
      Cookies.get("adress__") == null ||
      Cookies.get("adress__") === undefined ||
      Cookies.get("adress__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("adress__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var adress__ = secByte.toString(CryptoJS.enc.Utf8);

      if (adress__ == "") {
        return false;
      } else {
        return adress__;
      }
    }
  }


  getCity() {
    if (
      Cookies.get("city__") == null ||
      Cookies.get("city__") === undefined ||
      Cookies.get("city__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("city__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var city__ = secByte.toString(CryptoJS.enc.Utf8);

      if (city__ == "") {
        return false;
      } else {
        return city__;
      }
    }
  }

  getCountry() {
    if (
      Cookies.get("country__") == null ||
      Cookies.get("country__") === undefined ||
      Cookies.get("country__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("country__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var country__ = secByte.toString(CryptoJS.enc.Utf8);

      if (country__ == "") {
        return false;
      } else {
        return country__;
      }
    }
  }

  getState() {
    if (
      Cookies.get("state__") == null ||
      Cookies.get("state__") === undefined ||
      Cookies.get("state__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("state__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var state__ = secByte.toString(CryptoJS.enc.Utf8);

      if (state__ == "") {
        return false;
      } else {
        return state__;
      }
    }
  }

  getParentAcctAgent() {
    if (
      Cookies.get("agent_parent_accountno__") == null ||
      Cookies.get("agent_parent_accountno__") === undefined ||
      Cookies.get("agent_parent_accountno__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("agent_parent_accountno__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var agent_parent_accountno__ = secByte.toString(CryptoJS.enc.Utf8);

      if (agent_parent_accountno__ == "") {
        return false;
      } else {
        return agent_parent_accountno__;
      }
    }
  }

  getUserTypeAgent() {
    if (
      Cookies.get("agent_type__") == null ||
      Cookies.get("agent_type__") === undefined ||
      Cookies.get("agent_type__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("agent_type__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var agent_type__ = secByte.toString(CryptoJS.enc.Utf8);

      if (agent_type__ == "") {
        return false;
      } else {
        return agent_type__;
      }
    }
  }

  getZip() {
    if (
      Cookies.get("zip__") == null ||
      Cookies.get("zip__") === undefined ||
      Cookies.get("zip__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("zip__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var zip__ = secByte.toString(CryptoJS.enc.Utf8);

      if (zip__ == "") {
        return false;
      } else {
        return zip__;
      }
    }
  }

  getSharelinkLimit() {
    if (
      Cookies.get("sharelink_limit__") == null ||
      Cookies.get("sharelink_limit__") === undefined ||
      Cookies.get("sharelink_limit__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("sharelink_limit__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var sharelink_limit__ = secByte.toString(CryptoJS.enc.Utf8);

      if (sharelink_limit__ == "") {
        return false;
      } else {
        return sharelink_limit__;
      }
    }
  }

  getPhone() {
    if (
      Cookies.get("phone__") == null ||
      Cookies.get("phone__") === undefined ||
      Cookies.get("phone__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("phone__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var phone__ = secByte.toString(CryptoJS.enc.Utf8);

      if (phone__ == "") {
        return false;
      } else {
        return phone__;
      }
    }
  }

  getAccount() {
    if (
      Cookies.get("acn__") == null ||
      Cookies.get("acn__") === undefined ||
      Cookies.get("acn__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("acn__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var acn__ = secByte.toString(CryptoJS.enc.Utf8);

      if (acn__ == "") {
        return false;
      } else {
        return acn__;
      }
    }
  }

  getToken() {
    if (
      Cookies.get("tkn__") == null ||
      Cookies.get("tkn__") === undefined ||
      Cookies.get("tkn__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("tkn__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var tkn__ = secByte.toString(CryptoJS.enc.Utf8);

      if (tkn__ == "") {
        return false;
      } else {
        return tkn__;
      }
    }
  }

  getAdminType() {
    if (
      Cookies.get("admin_type__") == null ||
      Cookies.get("admin_type__") === undefined ||
      Cookies.get("admin_type__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("admin_type__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var admin_type__ = secByte.toString(CryptoJS.enc.Utf8);

      if (admin_type__ == "") {
        return false;
      } else {
        return admin_type__;
      }
    }
  }

  getAdminName() {
    if (
      Cookies.get("admin_name__") == null ||
      Cookies.get("admin_name__") === undefined ||
      Cookies.get("admin_name__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("admin_name__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var admin_name__ = secByte.toString(CryptoJS.enc.Utf8);

      if (admin_name__ == "") {
        return false;
      } else {
        return admin_name__;
      }
    }
  }

  getAdminFullName() {
    if (
      Cookies.get("full_name__") == null ||
      Cookies.get("full_name__") === undefined ||
      Cookies.get("full_name__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("full_name__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var full_name__ = secByte.toString(CryptoJS.enc.Utf8);

      if (full_name__ == "") {
        return false;
      } else {
        return full_name__;
      }
    }
  }

  getAdminEmail() {
    if (
      Cookies.get("admin_eml__") == null ||
      Cookies.get("admin_eml__") === undefined ||
      Cookies.get("admin_eml__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("admin_eml__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var admin_eml__ = secByte.toString(CryptoJS.enc.Utf8);

      if (admin_eml__ == "") {
        return false;
      } else {
        return admin_eml__;
      }
    }
  }

  getAdminAccount() {
    if (
      Cookies.get("admin_acc__") == null ||
      Cookies.get("admin_acc__") === undefined ||
      Cookies.get("admin_acc__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("admin_acc__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var admin_acc__ = secByte.toString(CryptoJS.enc.Utf8);

      if (admin_acc__ == "") {
        return false;
      } else {
        return admin_acc__;
      }
    }
  }

  getAdminToken() {
    if (
      Cookies.get("admin_token__") == null ||
      Cookies.get("admin_token__") === undefined ||
      Cookies.get("admin_token__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("admin_token__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var admin_token__ = secByte.toString(CryptoJS.enc.Utf8);

      if (admin_token__ == "") {
        return false;
      } else {
        return admin_token__;
      }
    }
  }

  getResellerIdentifier() {
    if (
      Cookies.get("resellerhash__") == null ||
      Cookies.get("resellerhash__") === undefined ||
      Cookies.get("resellerhash__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("resellerhash__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var resellerhash__ = secByte.toString(CryptoJS.enc.Utf8);

      if (resellerhash__ == "") {
        return false;
      } else {
        return resellerhash__;
      }
    }
  }

  getResellerReturnUrl() {
    if (
      Cookies.get("resellerreturnurl__") == null ||
      Cookies.get("resellerreturnurl__") === undefined ||
      Cookies.get("resellerreturnurl__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("resellerreturnurl__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var resellerreturnurl__ = secByte.toString(CryptoJS.enc.Utf8);

      if (resellerreturnurl__ == "") {
        return false;
      } else {
        return resellerreturnurl__;
      }
    }
  }

  getResellerPrivacyUrl() {
    if (
      Cookies.get("resellerprivacyurl__") == null ||
      Cookies.get("resellerprivacyurl__") === undefined ||
      Cookies.get("resellerprivacyurl__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("resellerprivacyurl__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var resellerprivacyurl__ = secByte.toString(CryptoJS.enc.Utf8);

      if (resellerprivacyurl__ == "") {
        return false;
      } else {
        return resellerprivacyurl__;
      }
    }
  }
  getResellerTermsUrl() {
    //Agent or Sub Agent
    if (
      Cookies.get("resellertermsurl__") == null ||
      Cookies.get("resellertermsurl__") === undefined ||
      Cookies.get("resellertermsurl__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("resellertermsurl__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var resellertermsurl__ = secByte.toString(CryptoJS.enc.Utf8);

      if (resellertermsurl__ == "") {
        return false;
      } else {
        return resellertermsurl__;
      }
    }
  }

  getResellerRegTitle() {
    //Agent or Sub Agent
    if (
      Cookies.get("resellercompanyname__") == null ||
      Cookies.get("resellercompanyname__") === undefined ||
      Cookies.get("resellercompanyname__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("resellercompanyname__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var resellercompanyname__ = secByte.toString(CryptoJS.enc.Utf8);

      if (resellercompanyname__ == "") {
        return false;
      } else {
        return resellercompanyname__;
      }
    }
  }

  getResellerLogo() {
    //Agent or Sub Agent
    if (
      Cookies.get("reslogo__") == null ||
      Cookies.get("reslogo__") === undefined ||
      Cookies.get("reslogo__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("reslogo__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var reslogo__ = secByte.toString(CryptoJS.enc.Utf8);

      if (reslogo__ == "") {
        return false;
      } else {
        return reslogo__;
      }
    }
  }

  getResellerSignature() {
    //Agent or Sub Agent
    if (
      Cookies.get("ressig__") == null ||
      Cookies.get("ressig__") === undefined ||
      Cookies.get("ressig__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("ressig__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var ressig__ = secByte.toString(CryptoJS.enc.Utf8);

      if (ressig__ == "") {
        return false;
      } else {
        return ressig__;
      }
    }
  }

  getSuperAgentTitle() {
    //Agent or Sub Agent
    if (
      Cookies.get("agttitle__") == null ||
      Cookies.get("agttitle__") === undefined ||
      Cookies.get("agttitle__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("agttitle__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var agttitle__ = secByte.toString(CryptoJS.enc.Utf8);

      if (agttitle__ == "") {
        return false;
      } else {
        return agttitle__;
      }
    }
  }

  getSuperAgentAcct() {
    //Agent or Sub Agent
    if (
      Cookies.get("agtacctno__") == null ||
      Cookies.get("agtacctno__") === undefined ||
      Cookies.get("agtacctno__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("agtacctno__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var agtacctno__ = secByte.toString(CryptoJS.enc.Utf8);

      if (agtacctno__ == "") {
        return false;
      } else {
        return agtacctno__;
      }
    }
  }

  getUrlType() {
    //Agent or Sub Agent
    if (
      Cookies.get("urltype__") == null ||
      Cookies.get("urltype__") === undefined ||
      Cookies.get("urltype__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("urltype__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var urltype__ = secByte.toString(CryptoJS.enc.Utf8);

      if (urltype__ == "") {
        return false;
      } else {
        return urltype__;
      }
    }
  }

  logout() {
    Cookies.remove("comp_nme__");
    Cookies.remove("eml__");
    Cookies.remove("acn__");
    Cookies.remove("tkn__");
    localStorage.removeItem("activeMenusCp");
    localStorage.removeItem("activeSubmenuItemCp");
    //Get Reseller Url
    var resByte = CryptoJS.AES.decrypt(
      Cookies.get("residentifier__"),
      process.env.REACT_APP_SIGNATURE
    );

    var residentifier = resByte.toString(CryptoJS.enc.Utf8);
    return window.location.replace("/" + residentifier);
  }

  adminlogout() {
    Cookies.remove("admin_name__");
    Cookies.remove("admin_type__");
    Cookies.remove("admin_eml__");
    Cookies.remove("admin_acc__");
    Cookies.remove("admin_token__");
    return window.location.replace("/nsaccess");
  }

  //CLIENT PORTAL HELPERS
  isClientLogin() {
    if (
      Cookies.get("client_acn__") == null ||
      Cookies.get("client_acn__") === undefined ||
      Cookies.get("client_acn__") === "" ||
      Cookies.get("client_tkn__") === undefined ||
      Cookies.get("client_tkn__") === null ||
      Cookies.get("client_tkn__") === ""
    ) {
      return false;
    } else {
      var bytes = CryptoJS.AES.decrypt(
        Cookies.get("client_tkn__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (bytes == "") {
        window.location.replace("/client");
        return false;
      }
      var client_tkn__ = bytes.toString(CryptoJS.enc.Utf8);

      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("client_acn__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        window.location.replace("/client");
        return false;
      }
      var client_acn__ = secByte.toString(CryptoJS.enc.Utf8);

      if (client_tkn__ == "" || client_acn__ == "") {
        window.location.replace("/client");
        return false;
      } else {
        return true;
      }
    }
  }

  getNameClient() {
    if (
      Cookies.get("client_name__") == null ||
      Cookies.get("client_name__") === undefined ||
      Cookies.get("client_name__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("client_name__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var client_name__ = secByte.toString(CryptoJS.enc.Utf8);

      if (client_name__ == "") {
        return false;
      } else {
        return client_name__;
      }
    }
  }

  getCountryClient() {
    if (
      Cookies.get("client_country__") == null ||
      Cookies.get("client_country__") === undefined ||
      Cookies.get("client_country__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("client_country__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var client_country__ = secByte.toString(CryptoJS.enc.Utf8);

      if (client_country__ == "") {
        return false;
      } else {
        return client_country__;
      }
    }
  }

  getCompNameClient() {
    if (
      Cookies.get("client_comp_nme__") == null ||
      Cookies.get("client_comp_nme__") === undefined ||
      Cookies.get("client_comp_nme__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("client_comp_nme__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var client_comp_nme__ = secByte.toString(CryptoJS.enc.Utf8);

      if (client_comp_nme__ == "") {
        return false;
      } else {
        return client_comp_nme__;
      }
    }
  }

  getFilerID() {
    if (
      Cookies.get("filer_id__") == null ||
      Cookies.get("filer_id__") === undefined ||
      Cookies.get("filer_id__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("filer_id__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var filer_id__ = secByte.toString(CryptoJS.enc.Utf8);

      if (filer_id__ == "") {
        return false;
      } else {
        return filer_id__;
      }
    }
  }

  getUserTypeClient() {
    if (
      Cookies.get("client_user_type__") == null ||
      Cookies.get("client_user_type__") === undefined ||
      Cookies.get("client_user_type__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("client_user_type__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var client_user_type__ = secByte.toString(CryptoJS.enc.Utf8);

      if (client_user_type__ == "") {
        return false;
      } else {
        return client_user_type__;
      }
    }
  }

  getParentAcctClient() {
    if (
      Cookies.get("client_parent_accountno__") == null ||
      Cookies.get("client_parent_accountno__") === undefined ||
      Cookies.get("client_parent_accountno__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("client_parent_accountno__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var client_parent_accountno__ = secByte.toString(CryptoJS.enc.Utf8);

      if (client_parent_accountno__ == "") {
        return false;
      } else {
        return client_parent_accountno__;
      }
    }
  }

  getEmailClient() {
    if (
      Cookies.get("client_eml__") == null ||
      Cookies.get("client_eml__") === undefined ||
      Cookies.get("client_eml__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("client_eml__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var client_eml__ = secByte.toString(CryptoJS.enc.Utf8);

      if (client_eml__ == "") {
        return false;
      } else {
        return client_eml__;
      }
    }
  }

  getClientAccount() {
    if (
      Cookies.get("client_acn__") == null ||
      Cookies.get("client_acn__") === undefined ||
      Cookies.get("client_acn__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("client_acn__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var client_acn__ = secByte.toString(CryptoJS.enc.Utf8);

      if (client_acn__ == "") {
        return false;
      } else {
        return client_acn__;
      }
    }
  }

  getClientToken() {
    if (
      Cookies.get("client_tkn__") == null ||
      Cookies.get("client_tkn__") === undefined ||
      Cookies.get("client_tkn__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("client_tkn__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var client_tkn__ = secByte.toString(CryptoJS.enc.Utf8);

      if (client_tkn__ == "") {
        return false;
      } else {
        return client_tkn__;
      }
    }
  }
  getPhoneClient() {
    if (
      Cookies.get("client_phone__") == null ||
      Cookies.get("client_phone__") === undefined ||
      Cookies.get("client_phone__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("client_phone__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var client_phone__ = secByte.toString(CryptoJS.enc.Utf8);

      if (client_phone__ == "") {
        return false;
      } else {
        return client_phone__;
      }
    }
  }
  getTitleClient() {
    if (
      Cookies.get("client_title__") == null ||
      Cookies.get("client_title__") === undefined ||
      Cookies.get("client_title__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("client_title__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var client_title__ = secByte.toString(CryptoJS.enc.Utf8);

      if (client_title__ == "") {
        return false;
      } else {
        return client_title__;
      }
    }
  }

  getDomainNameClient() {
    if (
      Cookies.get("client_domain_name__") == null ||
      Cookies.get("client_domain_name__") === undefined ||
      Cookies.get("client_domain_name__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("client_domain_name__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var client_domain_name__ = secByte.toString(CryptoJS.enc.Utf8);

      if (client_domain_name__ == "") {
        return false;
      } else {
        return client_domain_name__;
      }
    }
  }

  getClientService() {
    if (
      Cookies.get("clientserviceid__") == null ||
      Cookies.get("clientserviceid__") === undefined ||
      Cookies.get("clientserviceid__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("clientserviceid__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var clientserviceid__ = secByte.toString(CryptoJS.enc.Utf8);

      if (clientserviceid__ == "") {
        return false;
      } else {
        return clientserviceid__;
      }
    }
  }

  getClientServiceType() {
    if (
      Cookies.get("clientservicetype__") == null ||
      Cookies.get("clientservicetype__") === undefined ||
      Cookies.get("clientservicetype__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("clientservicetype__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var clientservicetype__ = secByte.toString(CryptoJS.enc.Utf8);

      if (clientservicetype__ == "") {
        return false;
      } else {
        return clientservicetype__;
      }
    }
  }

  getClientAddress() {
    if (
      Cookies.get("client_adress__") == null ||
      Cookies.get("client_adress__") === undefined ||
      Cookies.get("client_adress__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("client_adress__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var client_adress__ = secByte.toString(CryptoJS.enc.Utf8);

      if (client_adress__ == "") {
        return false;
      } else {
        return client_adress__;
      }
    }
  }


  getVAReturnUrl() {
    if (
      Cookies.get("client_return_url__") == null ||
      Cookies.get("client_return_url__") === undefined ||
      Cookies.get("client_return_url__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("client_return_url__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var client_return_url__ = secByte.toString(CryptoJS.enc.Utf8);

      if (client_return_url__ == "") {
        return false;
      } else {
        return client_return_url__;
      }
    }
  }

  getResellerRegToken() {
    if (
      Cookies.get("residentifier__") == null ||
      Cookies.get("residentifier__") === undefined ||
      Cookies.get("residentifier__") === ""
    ) {
      return false;
    } else {
      var secByte = CryptoJS.AES.decrypt(
        Cookies.get("residentifier__"),
        process.env.REACT_APP_SIGNATURE
      );
      if (secByte == "") {
        return false;
      }
      var residentifier__ = secByte.toString(CryptoJS.enc.Utf8);

      if (residentifier__ == "") {
        return false;
      } else {
        return residentifier__;
      }
    }
  }

  clientLogout() {
    Cookies.remove("client_name__");
    Cookies.remove("client_comp_nme__");
    Cookies.remove("client_eml__");
    Cookies.remove("client_acn__");
    Cookies.remove("client_tkn__");
    Cookies.remove("client_phone__");
    Cookies.remove("client_title__");
    Cookies.remove("client_return_url__");
    localStorage.removeItem("activeMenusClient")
    localStorage.removeItem("activeSubmenuItemClient")
    //Get Reseller Url
    var resByte = CryptoJS.AES.decrypt(
      Cookies.get("residentifier__"),
      process.env.REACT_APP_SIGNATURE
    );

    var residentifier = resByte.toString(CryptoJS.enc.Utf8);
    return window.location.replace("/" + residentifier + "/client/login");
  }

  formatUsPhoneNumber(number) {
    const cleaned = ("" + number).replace(/\D/g, "");
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return `(${match[1]}) ${match[2]}-${match[3]}`;
    }
    return number;
  }

  formatDateTime(date) {
    if (date && date !== "") {
      return dateFormat(date, "mmmm dS, yyyy, h:MM:ss TT");
    }
    return "---";
  }
  formatDate(date) {
    if (date && date !== "") {
      return dateFormat(date, "mmmm dS, yyyy");
    }
    return "---";
  }
}

export default HelperClass;
